/** @jsx jsx */
import { jsx } from '@emotion/react';
import React from 'react';
import { labelStyles, withModifier } from '@zapier/style-encapsulation';

type Props = {
  /** Any valid React node */
  children: React.ReactNode;

  /** Adjusts the horizontal padding */
  size?: 'large' | 'medium' | 'small';
};

const Styles = labelStyles('ContentSection', {
  root: (size: NonNullable<Props['size']>) => [
    {
      maxWidth: 1280,
      margin: '0 auto',
    },

    withModifier(
      size,
      {
        small: { padding: '0 10px' },
        medium: { padding: '0 20px' },
        large: { padding: '0 40px' },
      }[size]
    ),
  ],
});

/**
 * This component is used to cap the layout at the Zapier Design System
 * designated maximum width. Use this component around sections that contain
 * large blocks of text in order to maintain easy-to-read content on larger
 * screens.
 */
export const ContentSection = ({ children, size = 'small' }: Props) => (
  <div css={Styles.root(size)} data-zds>
    {children}
  </div>
);
